import axios from "axios";
import {
  FETCH_REPARACIONES_REQUEST,
  FETCH_REPARACIONES_SUCCESS,
  FETCH_REPARACIONES_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionReparacionesGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_REPARACIONES_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/reparaciones", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_REPARACIONES_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar reparaciones";
    dispatch({ type: FETCH_REPARACIONES_FAILURE, payload: { error: msg } });
  }
};

export const apiReparacionesInstance = api;
export { authHeader as authHeaderReparaciones };
